/**
 * Employee Web — `/me/profile` pathless parent for the 6-tab profile shell.
 *
 * Phase 05.2-05 Plan 05. Mounts <MeProfileLayout> which renders:
 *   - RenewalBanner (EW-14 carry-forward)
 *   - PageHeader ("My Profile")
 *   - ProfileHero (Avatar + name + status chips)
 *   - 6-tab strip (Personal / Work / Documents / Emergency / Bank & Tax / Security)
 *   - <Outlet> for the active tab content
 *
 * Per Critical Risk #1 in 05.2-RESEARCH: my-leave + my-attendance + punch
 * stay as SIBLING routes under `/me/*`, not inside this 6-tab shell.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { MeProfileLayout } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/profile")({
  staticData: { breadcrumb: { labelKey: "me-profile:page.title" } },
  component: MeProfilePathlessParent,
});

function MeProfilePathlessParent(): JSX.Element {
  return <MeProfileLayout />;
}
